import {BUSINESS_NAME} from "@/content";

export type ParallaxContent = {
    title: string;
    subTitle: string;
    overline: string;
    imageUrl: string;
    buttonCTA: string;
    tint: string;
    align: 'left' | 'right' | 'center';
    buttonLink: string;
};

export const parallaxContent1: Omit<ParallaxContent, 'buttonLink'> & { buttonLink?: string } = {
    title:'Growing Your Leads is in Our DNA',
    subTitle:'Get started today with a free consultation and let us help you grow your business online.',
    overline: BUSINESS_NAME,
    imageUrl:'/images/parallax/pllx-1.webp',
    buttonCTA:'Grow Your Leads Now',
    align:'left',
    tint:'rgba(85,101,100,0.49)',
    buttonLink:undefined, //define this in the page
}

export const parallaxContent2: Omit<ParallaxContent, 'buttonLink'> & { buttonLink?: string } = {
    title:'Business Profile Optimisation',
    subTitle:'Find your target audience and convert them into customers with a fully optimised Digital Business Profile.',
    overline: BUSINESS_NAME,
    imageUrl:'/images/parallax/pllx-2.jpg',
    buttonCTA:'Google Business Profile Optimisation',
    tint:'rgba(0, 0, 0, 0.3)',
    align:'right',
    buttonLink:undefined, //define this in the page
}
